export default {
  selectCreate({
    commit
  }, payload) {
    commit('SELECT_CREATE', payload);
  },
  toggleSettingSurat({
    commit
  }, payload) {
    commit('TOGGLE_SETTING_SURAT', payload);
  },
  toggleFormSignature({
    commit
  }, payload) {
    commit('TOGGLE_FORM_SIGNATURE', payload);
  },
  setDetailId({
    commit
  }, id) {
    commit('SET_DETAIL_ID', id);
  },

  selectEdit({
    commit
  }, payload) {
    commit('SELECT_EDIT', payload);
  },

  setEditId({
    commit
  }, payload) {
    commit('SET_EDIT_ID', payload);
  },

  setSettingSuratId({
    commit
  }, payload) {
    commit('SET_SETTING_SURAT_ID', payload)
  },

  toggleShowSurat({
    commit
  }, payload) {
    commit('TOGGLE_SHOW_SURAT', payload);
  },

  setShowSuratId({
    commit
  }, payload) {
    commit('SET_SHOW_SURAT_ID', payload)
  },
};
